import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './RatingStar.pcss';

const RatingStar = ({
  className,
  value,
  rating,
  onClick,
  ratingHighlighted,
  onMouseEnter,
  onMouseLeave,
  disabled
}) => {
  const classNames = cn(
    'RatingStar',
    {
      RatingStar_selected: value <= rating,
      RatingStar_disabled: value <= rating && disabled,
      RatingStar_highlighted:
        ratingHighlighted &&
        value <= ratingHighlighted &&
        (value === ratingHighlighted || value > rating) &&
        !disabled
    },
    className
  );

  return (
    <div
      onClick={() => !disabled && onClick(value)}
      onMouseEnter={() => !disabled && onMouseEnter(value)}
      onMouseLeave={() => !disabled && onMouseLeave(value)}
      className={classNames}
    />
  );
};

RatingStar.defaultProps = {
  rating: null,
  ratingHighlighted: null
};

RatingStar.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
  rating: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  ratingHighlighted: PropTypes.number
};

RatingStar.defaultProps = {
  className: ''
};

export default RatingStar;
